import PropTypes from 'prop-types';
import React from 'react';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new';
import FormRow from "../../edit-task/form-row";
import SelectTaskType from "core/gd-ui/select-task-type/select-task-type";

/*

We allow selecting ANY task type in company (not deleted)
i.e. we don't check for folder settings (!)
otherwise issue when do it from table etc. so better give them freedom
so we dont' use selct task type control and do a custom one ?

idea sdelat' tut selector tipo pokazivat' all task types ili razreshennie tol'ko ... hm...

 */

export default class ModalBulkTaskType extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        // projectId: PropTypes.string,
    };

    constructor(props) {
        super(props);

        const companyTaskTypes = gd.session.taskTypes.filterByCompany(gd.companyId)
        this.allowedTaskTypes = _.map(companyTaskTypes.models, tt => tt.id)

        const initFormData = {
            taskType: this.allowedTaskTypes[0]
        };

        const formStructure = {
            fields: {
                taskType: {
                    type: 'select',
                    isRequired: true,
                    // onUserChange: this.onTaskTypeSelected
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }


    onSubmit = (result) => {
        this.props.onSubmit(result);
    };

    render() {
        // const { projectId } = this.props;

        return (
            <Form form={this.form} submitLabel="Convert">
                <div className="tbl">
                    <FormRow title="Task Type" form={this.form} name="taskType">
                        <SelectTaskType form={this.form}
                                        name="taskType"
                                        multiselect={false}
                                        // projectId={projectId}
                                        renderValue="form"
                                        allowedTaskTypes={this.allowedTaskTypes}
                                        canHaveNoValue={false} />
                    </FormRow>

                </div>
            </Form>
        );
    }
}